module.exports = __webpack_public_path__ + "static/media/hair-cutting.2c1a700a.svg";